/**
 * @generated SignedSource<<010ac19a14e9650f55533e70ba692aa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExportToDocs_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToNotesIntegrationExport: boolean;
    };
  };
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentType": "ExportToDocs_viewer";
};
export type ExportToDocs_viewer$key = {
  readonly " $data"?: ExportToDocs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExportToDocs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportToDocs_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToNotesIntegrationExport",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "notes_integration_export"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e25f9292f33a0e36e3b419e38d85c797";

export default node;
